import { openAlertModal } from 'admin/actions/alert-modal';
import { createShopApplication } from 'admin/actions/shop-applications';
import { showShop, updateShop } from 'admin/actions/shops';
import { getActiveUserTagGroupsWithItems } from 'admin/actions/user-tag-group';
import { attachUserTag, detachUserTag, fetchUserTags } from 'admin/actions/user-tags';
import Select from 'admin/components/atoms/Select';
import TagSelectionEditor from 'admin/components/organisms/TagSelectionEditor';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import Input from 'admin/components/shared/Input';
import { USAGE_TYPE_OPTIONS } from 'admin/constants/usageType';
import { toQueryParams } from 'admin/utils';
import _ from 'lodash';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import styled from 'styled-components';
import { organizationManagerAllowed } from '~/javascripts/admin/authorities';
import { selectUserPrivateMoney } from '~/javascripts/admin/reducers/user-private-money';
import {
  hasParameterError,
  pickIssuerOrgCodeFromMoneys,
  pickIssuerPrivateMoneyFromMoneys,
  validateShopForm,
} from '~/javascripts/admin/utils/shopFormValidation';
import { createBadge } from '../../atoms/Badge';
import Required from '../../atoms/Required';
import ToggleSwitch from '../../atoms/ToggleSwitch';
import styles from './styles.scss';
import { testEmailAllowedLetters } from '~/javascripts/admin/utils/email';

const HeadOfficeBadge = createBadge(
  {
    isHeadOffice: { label: '本店', bgColor: '#3995FF', isRounded: false },
  },
  {
    styles: {
      borderRadius: '9999px',
      padding: '2px 12px',
      textAlign: 'center',
    },
  }
);

const LabeledError = styled.div`
  color: red;
`;

// 店舗ラベルは他の店舗情報とシステム特性が異なるため、視覚的に独立したセクションとして表示する。
const LabelSection = styled.div`
  margin: 16px 0;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
`;

const LabelSectionTitle = styled.div`
  font-weight: bold;
  color: #555;
  margin-bottom: 12px;
`;

class UpdateShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedShop: {},
      errorResponse: {},
      shopForm: {
        shop_name: '',
        shop_name_furigana: '',
        shop_tel: '',
        shop_email: '',
        shop_postal_code: '',
        shop_address: '',
        shop_external_id: '',
        contact_person_name: '',
        contact_person_name_furigana: '',
        can_topup: false,
        accounts: [],
        status: 'active',
        usage_type: '',
      },
      shopOrganization: null,
      // 商店街エリア / 業種:大分類 (UserTagGroup ベース)
      // existingTagId = UserTag (関連エンティティ) の id、detach 実行時に使用
      // existingItemId = UserTagGroupItem (マスタ) の id、差分判定に使用
      // selectedItemId = UI 上の現在選択値 (UserTagGroupItem.id)
      // 発行体orgの有効タググループ（正規化済み）
      availableTagGroups: [],
      // 現在のUI選択 [{ groupId, itemIds: [] }]（既存タグから初期化）
      tagSelections: [],
      // 既存付与タグ [{ tagId, groupId, itemId }]（差分計算に使用）
      existingTags: [],
      tagGroupsIssuerOrgCode: null,
      tagGroupsLoading: false,
      tagGroupsFetchFailed: false,
      tagUpdateWarning: false,
      moneyOptions: [],
      selectedMoneyOptions: [],
      isHeadOffice: false,
      isModalOpen: false,
      showMoneySelectionError: false,
      showShopNameError: false,
      emailError: false,
      emptyFieldErrors: {},
      formatFieldErrors: {},
    };
  }

  componentDidMount() {
    const query = toQueryParams({ withDisabled: true });
    showShop(this.props.match.params.id, query)
      .then((shop) => {
        const moneyOptions = this.toMoneyOptions(this.props.user.moneys());
        const alreadyMemberMoneyNames = shop.accounts.map((a) => a.private_money.name);
        const selectedMoneyOptions = moneyOptions.filter((m) =>
          alreadyMemberMoneyNames.includes(m.label)
        );
        const shopForm = {
          shop_name: shop.name,
          shop_name_furigana: shop.shop_name_furigana ?? '',
          shop_tel: shop.tel,
          shop_email: shop.email,
          shop_postal_code: shop.postal_code,
          shop_address: shop.address,
          shop_external_id: shop.external_id,
          contact_person_name: shop.contact_person_name ?? '',
          contact_person_name_furigana: shop.contact_person_name_furigana ?? '',
          private_money_ids: selectedMoneyOptions.map((op) => op.value.id),
          can_topup: shop.can_topup,
          status: shop.status,
          usage_type: shop.usage_type ?? '',
        };
        const isHeadOffice = shop.is_head_office;
        this.setState({
          shopForm,
          moneyOptions,
          selectedMoneyOptions,
          isHeadOffice,
          shopOrganization: shop.organization || null,
        });
        // タグ関連: 加盟マネー (pocketchange 除外) から発行体組織コードと発行体マネー id を取得 → fetch
        const selectedMoneys = selectedMoneyOptions.map((op) => op.value);
        const issuerOrgCode = pickIssuerOrgCodeFromMoneys(selectedMoneys);
        const issuerMoney = pickIssuerPrivateMoneyFromMoneys(selectedMoneys);
        this.loadTagGroupsAndExistingTags(issuerOrgCode, issuerMoney?.id ?? null, shop.id);
      })
      .catch((error) => {
        error.then((res) =>
          this.props.openAlertModal({ body: res.message ?? 'Something went wrong.' })
        );
      });
  }

  onSelectMoney = (options) => {
    // XXX
    const private_money_ids = options.map((op) => op.value.id);
    this.setShopForm('private_money_ids', private_money_ids);
    this.setState({ selectedMoneyOptions: options });
    // 発行体が変わった場合はタググループ/既存タグを再読込する（古い発行体のグループで
    // syncTagsForShop が誤った差分を出すのを防ぐ）。同一発行体なら loadTagGroupsAndExistingTags が早期 return。
    const selectedMoneys = options.map((op) => op.value);
    const issuerOrgCode = pickIssuerOrgCodeFromMoneys(selectedMoneys);
    const issuerMoney = pickIssuerPrivateMoneyFromMoneys(selectedMoneys);
    this.loadTagGroupsAndExistingTags(
      issuerOrgCode,
      issuerMoney?.id ?? null,
      this.props.match.params.id
    );
  };

  onClick(e) {
    e.preventDefault();

    const isMemberOrgUser = this.isMemberOrgUser();
    const validation = validateShopForm(this.state.shopForm, {
      isMemberOrgUser,
      isMoneySelected: this.isMoneySelected(),
    });

    this.setState({
      showMoneySelectionError: validation.showMoneySelectionError,
      showShopNameError: validation.showShopNameError,
      emailError: validation.emailError,
      emptyFieldErrors: validation.emptyFieldErrors,
      formatFieldErrors: validation.formatFieldErrors,
    });

    if (validation.hasError) {
      return;
    }

    const userTagGroupItemIds = this.state.tagSelections
      .flatMap((row) => row.itemIds)
      .filter(Boolean);

    // 加盟組織ユーザは発行体審査を伴う申請フローを通る。
    // POST /api/shop-applications (kind=update, target_shop_id 指定) で店舗変更申込みを送信。
    // organization_code は target_shop から自動決定されるため省略する。
    if (isMemberOrgUser) {
      const { shopForm } = this.state;
      const applicationPayload = {
        target_shop_id: this.props.match.params.id,
        shop_name: shopForm.shop_name,
        shop_name_furigana: shopForm.shop_name_furigana,
        postal_code: shopForm.shop_postal_code,
        address: shopForm.shop_address,
        tel: shopForm.shop_tel,
        email: shopForm.shop_email,
        contact_person_name: shopForm.contact_person_name,
        contact_person_name_furigana: shopForm.contact_person_name_furigana,
        private_money_ids: shopForm.private_money_ids,
        usage_type: shopForm.usage_type,
        ...(userTagGroupItemIds.length > 0 && { user_tag_group_item_ids: userTagGroupItemIds }),
      };
      createShopApplication(applicationPayload).then((json) =>
        json.id
          ? this.setState({ updatedShop: json, errorResponse: {} })
          : this.setState({ updatedShop: {}, errorResponse: json })
      );
      return;
    }

    // 発行体直接モード: shop 更新成功後、各 group の既存タグを detach → 新規 attach → 店舗詳細へ遷移
    updateShop(this.props.match.params.id, this.state.shopForm).then((json) => {
      if (!json.name) {
        this.setState({ updatedShop: {}, errorResponse: json });
        return;
      }
      this.setState({ updatedShop: json, errorResponse: {}, tagUpdateWarning: false });
      const goToDetail = () => this.props.history.push(`/shops/${json.id}`);
      this.syncTagsForShop(json.id)
        .then(goToDetail)
        .catch((err) => {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error('Failed to sync user tags', err);
          }
          // タグ更新失敗時は遷移せず編集画面に留まり warning Alert を表示
          this.setState({ tagUpdateWarning: true });
        });
    });
  }

  isEmptyField(key) {
    return Boolean(this.state.emptyFieldErrors[key]);
  }

  formatErrorOf(key) {
    return this.state.formatFieldErrors[key];
  }

  isMemberOrgUser() {
    const { selectedPrivateMoney, user } = this.props;
    return !!selectedPrivateMoney && !user.isIssuerOfMoney(selectedPrivateMoney);
  }

  setTagSelections = (next) => {
    this.setState({ tagSelections: next });
  };

  // shop 更新成功後に呼ばれる。現在のUI選択(tagSelections)と既存タグ(existingTags)の差分を計算し、
  // 不要になったタグを detach、新規に選ばれたタグを attach する。multi値・グループ内変更に対応。
  // 管理対象は有効グループ(availableTagGroups)に限定し、無効化されたグループの既存タグは保持する。
  // detach→attach の順序を保証し、attach は逐次実行して user_tag_already_exists を避ける。
  async syncTagsForShop(shopId) {
    const managedGroupIds = this.state.availableTagGroups.map((g) => g.id);
    const desiredItemIds = this.state.tagSelections.flatMap((row) => row.itemIds).filter(Boolean);
    const existingManaged = this.state.existingTags.filter((e) =>
      managedGroupIds.includes(e.groupId)
    );
    const existingItemIds = existingManaged.map((e) => e.itemId);

    const toDetach = existingManaged.filter((e) => !desiredItemIds.includes(e.itemId));
    const toAttach = desiredItemIds.filter((id) => !existingItemIds.includes(id));

    if (toDetach.length === 0 && toAttach.length === 0) return;
    // detach 完了 → attach の順序保証
    await Promise.all(toDetach.map((e) => detachUserTag(shopId, e.tagId)));
    for (const itemId of toAttach) {
      // eslint-disable-next-line no-await-in-loop
      await attachUserTag(shopId, itemId);
    }
  }

  loadTagGroupsAndExistingTags(issuerOrgCode, issuerPrivateMoneyId, shopId) {
    // 同一発行体なら再読込不要
    if (issuerOrgCode === this.state.tagGroupsIssuerOrgCode) return;
    // 発行体が無くなった場合はクリア（前発行体の選択を残さない）
    if (!issuerOrgCode) {
      this.setState({
        tagGroupsIssuerOrgCode: null,
        availableTagGroups: [],
        existingTags: [],
        tagSelections: [],
        tagGroupsFetchFailed: false,
      });
      return;
    }
    this.setState({ tagGroupsIssuerOrgCode: issuerOrgCode, tagGroupsLoading: true });
    // 組織切替時に古いレスポンスで上書きしないための stale ガード
    const requestedOrgCode = issuerOrgCode;
    const isStale = () => this.state.tagGroupsIssuerOrgCode !== requestedOrgCode;
    const groupsPromise = getActiveUserTagGroupsWithItems(issuerOrgCode);
    // 加盟組織ユーザでも発行体組織のタグを取得できるよう private_money_id を指定
    const tagsQuery = issuerPrivateMoneyId ? `private_money_id=${issuerPrivateMoneyId}` : '';
    const existingTagsPromise = fetchUserTags(shopId, tagsQuery).catch(() => ({ rows: [] }));
    Promise.all([groupsPromise, existingTagsPromise])
      .then(([groups, tagsRes]) => {
        if (isStale()) return;
        const existingTags = tagsRes.rows.map((t) => ({
          tagId: t.id,
          groupId: t.user_tag_group.id,
          itemId: t.user_tag_group_item.id,
        }));
        // 既存タグを有効グループ単位に集約して初期選択へ（無効グループのタグは表示対象外）
        const activeGroupIds = groups.map((g) => g.id);
        const tagSelections = groups
          .map((group) => ({
            groupId: group.id,
            itemIds: existingTags
              .filter((e) => e.groupId === group.id)
              .map((e) => e.itemId),
          }))
          .filter((row) => row.itemIds.length > 0 && activeGroupIds.includes(row.groupId));
        this.setState({
          availableTagGroups: groups,
          existingTags,
          tagSelections,
          tagGroupsLoading: false,
          tagGroupsFetchFailed: false,
        });
      })
      .catch((err) => {
        if (isStale()) return;
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.error('Failed to load user tag groups', err);
        }
        // 再試行可能にするため tagGroupsIssuerOrgCode を null に戻す
        this.setState({
          tagGroupsLoading: false,
          tagGroupsFetchFailed: true,
          tagGroupsIssuerOrgCode: null,
        });
      });
  }

  isInvalidParameter(param) {
    return hasParameterError(this.state.errorResponse, 'invalid', param);
  }

  isMissingParameter(param) {
    return hasParameterError(this.state.errorResponse, 'missing', param);
  }

  isShopNameConflict() {
    return (
      !_.isEmpty(this.state.errorResponse) && this.state.errorResponse.type === 'shop_name_conflict'
    );
  }

  isShopUserNotFound() {
    return (
      !_.isEmpty(this.state.errorResponse) &&
      this.state.errorResponse.type === 'shop_user_not_found'
    );
  }

  isUnavailablePrivateMoney() {
    return (
      !_.isEmpty(this.state.errorResponse) &&
      this.state.errorResponse.type === 'unavailable_private_money'
    );
  }

  isMoneySelected() {
    return (
      !_.isEmpty(this.state.selectedMoneyOptions) && this.state.selectedMoneyOptions.length > 0
    );
  }

  isSuccess() {
    if (_.isEmpty(this.state.updatedShop)) return false;
    // 発行体モード: Shop レスポンス (.name)、加盟組織モード: ShopApplication レスポンス (.shop_name)
    const responseShopName =
      this.state.updatedShop.name || this.state.updatedShop.shop_name;
    return responseShopName === this.state.shopForm.shop_name;
  }

  setShopForm(property, value) {
    const { shopForm } = this.state;
    shopForm[property] = value;
    this.setState({ shopForm });
  }

  toMoneyOptions = (moneys) => moneys.map((m) => ({ label: m.name, value: m }));

  render() {
    // 加盟組織ユーザ (= 選択中マネーの発行体ではない) は編集ではなく "変更申請" を出す
    const isMemberOrgUser = this.isMemberOrgUser();
    const pageTitle = isMemberOrgUser ? '店舗変更申請' : '店舗情報の編集';
    const submitButtonLabel = isMemberOrgUser ? '変更の審査申請' : '更新';
    const crumbLastValue = isMemberOrgUser ? '店舗変更申請' : '店舗編集';

    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '店舗管理', href: '', active: true },
      { value: '店舗一覧', href: '/shops', active: false },
      { value: crumbLastValue, href: '', active: true },
    ];

    const canTopupOptions = [
      { name: '可', value: 'enable' },
      { name: '不可', value: 'disable' },
    ];

    const { showMoneySelectionError, showShopNameError, emailError, shopOrganization } = this.state;

    const organizationOptions = shopOrganization
      ? [{ label: shopOrganization.name, value: shopOrganization.code }]
      : [];
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">{pageTitle}</div>
        <div styleName="section-title">基本情報</div>
        <form onSubmit={this.onClick.bind(this)}>
          <div styleName="row">
            <div styleName="label">
              組織名
              <Required />
            </div>
            <div styleName="form-item">
              <Select
                options={organizationOptions}
                value={organizationOptions[0] || null}
                onChange={() => {}}
                isDisabled
                placeholder="-"
                fullWidth
              />
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              加盟するマネー
              <Required />
            </div>
            <div styleName="form-item">
              <Select
                options={this.state.moneyOptions}
                value={this.state.selectedMoneyOptions}
                onChange={this.onSelectMoney}
                isMulti
                placeholder="加盟するマネーを選択して下さい"
                fullWidth
              />
              {showMoneySelectionError && (
                <LabeledError>加盟するマネーを選択してください</LabeledError>
              )}
              {this.isMissingParameter('private_money_ids') && (
                <LabeledError>加盟するマネーを選択してください</LabeledError>
              )}
            </div>
          </div>
          <Alert color="danger" isOpen={this.isUnavailablePrivateMoney()}>
            利用できないマネーが含まれています
          </Alert>
          <div styleName="row">
            <div styleName="label">
              店舗名
              <Required />
              {this.state.isHeadOffice && (
                <span style={{ marginLeft: '16px' }}>
                  <HeadOfficeBadge status="isHeadOffice" />
                </span>
              )}
            </div>
            <div styleName="form-item">
              <Input
                value={this.state.shopForm.shop_name}
                onChange={(e) => this.setShopForm('shop_name', e.target.value)}
              />
              {showShopNameError && <LabeledError>店舗名を入力してください</LabeledError>}
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_name')}>
                店舗名は必須で、256文字以下の文字列である必要があります
              </Alert>
              <Alert color="danger" isOpen={this.isShopNameConflict()}>
                この店舗名は既に登録されています
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              店舗名（フリガナ）
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                value={this.state.shopForm.shop_name_furigana}
                onChange={(e) => this.setShopForm('shop_name_furigana', e.target.value)}
              />
              {this.isEmptyField('shop_name_furigana') && (
                <LabeledError>店舗名（フリガナ）を入力してください</LabeledError>
              )}
              {this.formatErrorOf('shop_name_furigana') && (
                <LabeledError>{this.formatErrorOf('shop_name_furigana')}</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_name_furigana')}>
                店舗名（フリガナ）は256文字以下の文字列である必要があります
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              店舗形態
              <Required />
            </div>
            <div styleName="form-item">
              <Select
                options={USAGE_TYPE_OPTIONS}
                value={
                  USAGE_TYPE_OPTIONS.find((o) => o.value === this.state.shopForm.usage_type) || null
                }
                onChange={(opt) => this.setShopForm('usage_type', opt ? opt.value : '')}
                placeholder="店舗形態を選択してください"
                fullWidth
              />
              {this.isEmptyField('usage_type') && (
                <LabeledError>店舗形態を選択してください</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('usage_type')}>
                不正な店舗形態です
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              郵便番号
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                placeholder="例）0001111"
                value={this.state.shopForm.shop_postal_code}
                validations={[]}
                onChange={(e) => this.setShopForm('shop_postal_code', e.target.value)}
              />
              {this.isEmptyField('shop_postal_code') && (
                <LabeledError>郵便番号を入力してください</LabeledError>
              )}
              {this.formatErrorOf('shop_postal_code') && (
                <LabeledError>{this.formatErrorOf('shop_postal_code')}</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_postal_code')}>
                不正な郵便番号です
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              住所
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                value={this.state.shopForm.shop_address}
                onChange={(e) => this.setShopForm('shop_address', e.target.value)}
              />
              {this.isEmptyField('shop_address') && (
                <LabeledError>住所を入力してください</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_address')}>
                不正な住所の文字列です。住所は256文字以下の文字列である必要があります
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              電話番号
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                placeholder="例）08012345678"
                value={this.state.shopForm.shop_tel}
                type="tel"
                onChange={(e) => this.setShopForm('shop_tel', e.target.value)}
              />
              {this.isEmptyField('shop_tel') && (
                <LabeledError>電話番号を入力してください</LabeledError>
              )}
              {this.formatErrorOf('shop_tel') && (
                <LabeledError>{this.formatErrorOf('shop_tel')}</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_tel')}>
                不正な電話番号です
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              メールアドレス
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                placeholder="例）pokepay@example.com"
                value={this.state.shopForm.shop_email}
                onChange={(e) =>
                  testEmailAllowedLetters(e.target.value) &&
                  this.setShopForm('shop_email', e.target.value)
                }
              />
              {this.isEmptyField('shop_email') && (
                <LabeledError>メールアドレスを入力してください</LabeledError>
              )}
              {emailError && <LabeledError>{emailError}</LabeledError>}
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_email')}>
                不正なメールアドレスです
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              担当者名
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                value={this.state.shopForm.contact_person_name}
                onChange={(e) => this.setShopForm('contact_person_name', e.target.value)}
              />
              {this.isEmptyField('contact_person_name') && (
                <LabeledError>担当者名を入力してください</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('contact_person_name')}>
                担当者名は256文字以下の文字列である必要があります
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              担当者名（フリガナ）
              {isMemberOrgUser && <Required />}
            </div>
            <div styleName="form-item">
              <Input
                value={this.state.shopForm.contact_person_name_furigana}
                onChange={(e) => this.setShopForm('contact_person_name_furigana', e.target.value)}
              />
              {this.isEmptyField('contact_person_name_furigana') && (
                <LabeledError>担当者名（フリガナ）を入力してください</LabeledError>
              )}
              {this.formatErrorOf('contact_person_name_furigana') && (
                <LabeledError>{this.formatErrorOf('contact_person_name_furigana')}</LabeledError>
              )}
              <Alert color="danger" isOpen={this.isInvalidParameter('contact_person_name_furigana')}>
                担当者名（フリガナ）は256文字以下の文字列である必要があります
              </Alert>
            </div>
          </div>
          <LabelSection>
            <LabelSectionTitle>店舗ラベル</LabelSectionTitle>
            {this.state.tagGroupsLoading ? (
              <div>読み込み中...</div>
            ) : (
              <TagSelectionEditor
                groups={this.state.availableTagGroups}
                value={this.state.tagSelections}
                onChange={this.setTagSelections}
              />
            )}
            <Alert
              color="warning"
              isOpen={this.state.tagGroupsFetchFailed}
              style={{ marginTop: 8 }}
            >
              店舗ラベルの取得に失敗しました。ページを再読み込みしてください。
            </Alert>
          </LabelSection>
          <div styleName="row">
            <div styleName="label">外部ID</div>
            <div styleName="form-item">
              <Input
                value={this.state.shopForm.shop_external_id}
                validations={[]}
                onChange={(e) => this.setShopForm('shop_external_id', e.target.value)}
              />
              <Alert color="danger" isOpen={this.isInvalidParameter('shop_external_id')}>
                外部IDは36文字以内の半角英数字記号である必要があります
              </Alert>
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">状態</div>
            <div styleName="form-item">
              {organizationManagerAllowed.indexOf(this.props.user.role) !== -1 ? (
                <ToggleSwitch
                  checked={this.state.shopForm.status === 'active'}
                  onChange={(checked) =>
                    this.setShopForm('status', checked ? 'active' : 'disabled')
                  }
                  disabled={!!this.state.isHeadOffice}
                />
              ) : (
                <span>{this.state.shopForm.status === 'active' ? '有効' : '無効'}</span>
              )}
            </div>
          </div>

          {/* <div styleName="row">
            <div styleName="label">チャージ</div>
            <div styleName="form-item">
              <Select
                options={canTopupOptions}
                value={this.state.shopForm.can_topup ? 'enable' : 'disable'}
                onChange={e => this.setShopForm('can_topup', e.target.value === 'enable')}
              />
            </div>
          </div> */}
          <div styleName="button-group">
            <Button type="submit">{submitButtonLabel}</Button>
          </div>
          <Alert color="success" isOpen={this.isSuccess()}>
            {isMemberOrgUser
              ? '店舗の変更申請を完了しました'
              : '店舗情報の更新に成功しました'}
          </Alert>
          <Alert color="danger" isOpen={this.isShopUserNotFound()}>
            店舗が見つかりません
          </Alert>
          <Alert color="warning" isOpen={this.state.tagUpdateWarning}>
            店舗情報は更新されましたが、商店街エリア / 業種:大分類 タグの更新に失敗しました。もう一度更新するか、ページを再読み込みしてください。
          </Alert>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  selectedPrivateMoney: selectUserPrivateMoney(state),
});

export default connect(mapStateToProps, { openAlertModal })(CSSModules(UpdateShop, styles));
